/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';

import { ErrorMessage } from '@hookform/error-message';
import useApi from '../hooks/useApi';
import useListenSize from '../hooks/useListenSize';
import { segmentEvent } from '../helpers/sendEvent';
import formatStringToMask from '../helpers/formatStringToMask';
import fullStoryIdentify from '../helpers/fullStoryIdentify';
import { verifyResponseLog } from '../helpers/log';

import {
  addVerificationCode,
  checkoutDecision,
  addPayFrequencyLookup,
  setCheckoutLookupData,
  setupFeatureGates,
  addPhoneWithMask,
  addVwoDecision,
  setupToken,
  addUserId,
} from '../redux/actions';

import ErrorHandling from '../components/ErrorHandling/index';
import SubmitButton from '../components/SubmitButton';

function VerificationCodeSubmission() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const { request, response, loading, error } = useApi();

  const dispatch = useDispatch();
  const store = useSelector(state => ({
    payfrequencyExists: state.loanInfo?.payfrequencyExists,
    vwo: state.loanInfo?.vwo,
    phone: state.contact?.phone,
    error: state.technical?.error,
    firstName: state.personal?.firstName,
    phoneWithMask: state.contact?.phoneWithMask,
    uid: state.loanInfo?.uid,
    sessionId: state.technical?.segmentSessionId,
    route: state.technical?.route,
    offerToken: state.technical?.initialize?.offerToken,
    availableLimit: state.loanInfo?.availableLimit,
    synchrony: state.technical?.synchrony,
    synchronyPhoneChanged: state.technical?.synchronyPhoneChanged,
    retailerId: state.technical?.retailerId,
    retailerName: state.technical?.retailerName,
    shopify: state.technical?.shopify,
    offerPageFlow: state.technical?.offerPageFlow,
    isInstoreVccFlow: state.technical?.instoreVccFlow?.isInstoreVccFlow,
  }));

  const [resend, setResend] = useState(true);
  // const [emailResend, setEmailResend] = useState(true);
  const [smsMarketing, setSmsMarketing] = useState(true);
  const [emailMarketing, setEmailMarketing] = useState(true);
  const history = useHistory();
  useListenSize();

  useEffect(() => {
    if (store.shopify?.isShopify) {
      history.push('/new-user-flow');
    }
    if (store.offerPageFlow?.isOfferPageFlow) {
      history.push('/display-offered-lease-details');
    }
    if (store.isInstoreVccFlow) {
      history.push('/new-user-flow');
    }
  }, []);

  useEffect(() => {
    if (store.phone) {
      segmentEvent('identify', store.phone, { uid: store.phone }, store.sessionId);
      setTimeout(() => segmentEvent('page', 'Mobile Verification'), 1000);
      fullStoryIdentify({ phone: store.phone, uid: store.uid, firstName: store.firstName });
      // Send phone number to parent window
      if (window.top) {
        window.top.postMessage({ message: `phone-${store.phone}` }, window.location.origin);
      }
    }
  }, [store.phone]);

  useEffect(() => {
    if (store.route) {
      history.push(store.route);
    }
  }, [store.route]);

  useEffect(() => {
    const sendCode = async () => {
      const payFrequencyToken = store.synchrony?.isSynchrony ? store.synchrony.appUid : store.offerToken;
      const payFrequencyLook = await request.payFrequencyLookup({ uid: payFrequencyToken });
      if (payFrequencyLook) {
        dispatch(addPayFrequencyLookup(payFrequencyLook));
        dispatch(setupFeatureGates(payFrequencyLook.feature_gates));
        dispatch(addPhoneWithMask(formatStringToMask(payFrequencyLook.phone, '(###) ###-####')));
        if (payFrequencyLook.user_id) {
          dispatch(addUserId(payFrequencyLook.user_id));
        }
        if (payFrequencyLook.vwo?.[0]?.campaign_name?.includes('wayfair-offer-page')) {
          dispatch(
            addVwoDecision({
              feature: 'offerPage',
              variation: payFrequencyLook.vwo[0].wayfair_offer_page,
            }),
          );
        }

        if (payFrequencyLook?.X_Retailer_Token) {
          dispatch(setupToken(payFrequencyLook.X_Retailer_Token));
        }

        await request.loginRequest({ phone: payFrequencyLook.phone || store.phone });

        if (store.synchrony?.isSynchrony) {
          segmentEvent('page', 'Synchrony pre approval', {
            retailer_id: payFrequencyLook.retailer_id,
            retailer_name: payFrequencyLook.retailer_name,
            customer_name: payFrequencyLook.first_name,
            customer_id: payFrequencyLook.uid,
          });
        }
      }
    };
    if (
      /* eslint-disable */
      window?.location?.search !== '?reference=blockedSMS' &&
      !store.synchronyPhoneChanged &&
      !store.shopify &&
      !store.offerPageFlow?.isOfferPageFlow &&
      !store.isInstoreVccFlow
      /* eslint-disable */
    ) {
      sendCode();
    }
  }, []);

  const resendValidationCode = async () => {
    setResend(false);
    await request.loginRequest({ phone: store.phone });
    setTimeout(() => setResend(true), 10000);
  };

  // const resendValidationCodeToEmail = async () => {
  //   setEmailResend(false);
  //   await request.sendCodeToEmailRequest({ phone: store.phone });
  //   setTimeout(() => setEmailResend(true), 10000);
  // };

  const onSubmit = async values => {
    segmentEvent('track', 'Mobile Verification Submitted', {
      available_limit: store.availableLimit,
    });
    const verifyPayload = {
      ...values,
      phone: store.phone,
      sms_marketing: smsMarketing || false,
      email_marketing: emailMarketing || false,
    };

    const confirmationLoginRequest = await request.confirmationLoginRequest(verifyPayload);
    verifyResponseLog(response);

    if (confirmationLoginRequest) {
      dispatch(addVerificationCode(values.code));
      segmentEvent('track', 'Mobile Number Verification Passed');

      if (!store.payfrequencyExists) {
        console.log('Pay Frequency does not exist');
        history.push('/pay-check-details');
      } else if (store.payfrequencyExists && store.synchrony?.isSynchrony) {
        history.push('/congratulation');
      } else {
        const payload = { uid: store.uid };
        // eslint-disable-next-line no-console
        console.log('checkout endpoint payload: ', payload);
        const checkoutRequest = await request.checkoutRequest(payload);
        // eslint-disable-next-line no-console
        console.log('checkout endpoint response: ', checkoutRequest, checkoutRequest?.app_id);
        dispatch(
          setCheckoutLookupData({
            appId: checkoutRequest?.app_id,
          }),
        );
        if (checkoutRequest?.status === 400 && checkoutRequest?.reason?.includes('existing non-performing leases')) {
          history.push('/due-payment');
        }

        if (checkoutRequest?.vwo?.length > 0) {
          dispatch(
            addVwoDecision({
              feature: 'checkoutPage',
              variation: checkoutRequest.vwo[0]?.wayfair_payment_page,
            }),
          );
        }

        dispatch(checkoutDecision({ response: checkoutRequest }));
      }
    }
  };

  return (
    <div className="k-content-wrapper">
      <ErrorHandling response={response} error={error} />
      {!store.synchrony?.isSynchrony && (
        <section className="k-info">
          <h1>
            Enter the code sent to
            <span className="k-primary"> {store.phoneWithMask}</span>
          </h1>
        </section>
      )}
      {store.synchrony?.isSynchrony && (
        <section className="k-info synchrony-top-section">
          <h1 className="synchrony-main-title">We just sent you a text</h1>
          <span className="synchrony-sub-title">Enter the verification code sent to {store.phoneWithMask}</span>
        </section>
      )}
      <section className="k-form k-form-indent">
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <div className="k-field animate__animated animate__fadeInDown">
            <button
              type="button"
              className="k-btn-link k-btn-link-inside-input"
              disabled={!resend}
              onClick={resendValidationCode}
            >
              {resend ? 'Resend' : 'Code sent'}
            </button>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="code">Code</label>
            <input
              type="tel"
              name="code"
              maxLength="6"
              id="code"
              autoComplete="off"
              placeholder="••••••"
              {...register('code', {
                required: 'This is required',
                pattern: {
                  value: /\d{6}/,
                  message: 'Should be 6 numeric digits ',
                },
              })}
            />
            <div className="k-form-validation-message">
              <ErrorMessage errors={errors} name="code" render={({ message }) => message} />
            </div>
          </div>
          {!store.synchrony?.isSynchrony && (
            <>
              {/* <div className="k-form-send-to-email">
                <button
                  type="button"
                  className="k-btn-link"
                  disabled={!emailResend}
                  onClick={resendValidationCodeToEmail}
                >
                  {emailResend ? 'Email me the code' : 'Code sent to email'}
                </button>
              </div> */}

              <div className="k-field">
                <label htmlFor="consent" className="subscribe-to-sms">
                  <input
                    type="checkbox"
                    name="consent"
                    className="subscribe-to-sms-input"
                    data-testid="consent"
                    {...register('consent', {
                      required: 'You must consent to the terms and conditions to proceed',
                    })}
                  />
                  <span className="subscribe-to-sms-text">
                    I've read, understand and consent to the{' '}
                    <a href="https://katapult.com/app/credit-disclosure" target="_blank" rel="noreferrer">
                      Credit Report Disclosure
                    </a>
                    ,{' '}
                    <a href="https://katapult.com/app/privacy-policy" target="_blank" rel="noreferrer">
                      Privacy Policy
                    </a>
                    ,{' '}
                    <a href="https://katapult.com/app/terms-of-use" target="_blank" rel="noreferrer">
                      Terms of Use
                    </a>{' '}
                    and{' '}
                    <a href="https://katapult.com/app/esign-disclosure" target="_blank" rel="noreferrer">
                      ESIGN disclosure
                    </a>{' '}
                    and agree that Katapult may contact me by SMS for login info & account information. Message & data
                    rates may apply. Message frequency may vary.
                  </span>
                </label>
                <div className="k-form-validation-message">
                  <ErrorMessage errors={errors} name="consent" render={({ message }) => message} />
                </div>
              </div>

              <div className="k-field">
                <label htmlFor="subscribetosms" className="subscribe-to-sms">
                  <input
                    type="checkbox"
                    name="subscribetosms"
                    className="subscribe-to-sms-input"
                    data-testid="subscribetosms"
                    defaultChecked
                    onClick={() => setSmsMarketing(!smsMarketing)}
                  />
                  <span className="subscribe-to-sms-text">
                    I would like to receive marketing messages from Katapult through SMS to the phone number provided.
                  </span>
                </label>
              </div>
              <div className="k-field">
                <label htmlFor="subscribetoemail" className="subscribe-to-sms">
                  <input
                    type="checkbox"
                    name="subscribetoemail"
                    className="subscribe-to-sms-input"
                    defaultChecked
                    data-testid="subscribetoemail"
                    onClick={() => setEmailMarketing(!emailMarketing)}
                  />
                  <span className="subscribe-to-sms-text">
                    I would like to receive marketing messages from Katapult through email.
                  </span>
                </label>
              </div>
            </>
          )}
          {store.synchrony?.isSynchrony && (
            <div className="k-field animate__animated animate__fadeInDown">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="ssn">Last 4 digits of SSN</label>
              <input
                type="tel"
                name="ssn"
                maxLength="4"
                id="ssn"
                autoComplete="off"
                placeholder="••••"
                className="fs-exclude"
                {...register('ssn', {
                  required: 'This is required',
                  pattern: {
                    value: /\d{4}/,
                    message: 'Should be 4 numeric digits ',
                  },
                })}
              />
              <div className="k-form-validation-message">
                <ErrorMessage errors={errors} name="ssn" render={({ message }) => message} />
              </div>
            </div>
          )}
          {store.phoneWithMask && store.phone && store.error === 'sms_blocked' && (
            <>
              <Redirect to="/blocked-verification-code" />
              <div className="k-sms-blocked">
                <p>
                  <strong>Text START 91948 to reactivate SMS</strong>
                </p>
                <p>
                  You previously requested to stop receiving SMS, but we need to send you a six-digit code so you can
                  verify your identity.
                </p>
              </div>
            </>
          )}
          {store.synchrony?.isSynchrony && (
            <div>
              <section className="synchrony-terms">
                <input
                  type="checkbox"
                  name="terms"
                  id="terms"
                  {...register('terms', {
                    required: 'This is required',
                  })}
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="terms" className="synchrony-terms-label">
                  By checking this box, I confirm that I have read, understand, and consent to the{' '}
                  <a href="https://katapult.com/app/credit-disclosure" rel="noreferrer" target="_blank">
                    Credit Report Disclosures
                  </a>
                  ,{' '}
                  <a href="https://katapult.com/app/privacy-policy" rel="noreferrer" target="_blank">
                    Privacy Policy
                  </a>
                  ,{' '}
                  <a href="https://katapult.com/app/esign-disclosure" rel="noreferrer" target="_blank">
                    ESIGN Disclosure
                  </a>
                  , and{' '}
                  <a href="https://katapult.com/app/terms-of-use" rel="noreferrer" target="_blank">
                    Terms of Use
                  </a>
                  , which contain a binding arbitration agreement. If declined by Katapult, I consent to my application
                  being submitted to Katapult affiliates Aaron&apos;s, LLC and Community Choice Financial, Inc. (the
                  &quot;Authorized Entities&quot;) and for the Authorized Entities to obtain and use consumer reports
                  about me in connection with my application(s). I agree that Katapult and the Authorized Entities may
                  contact me by text, SMS, and MMS for login info and other application and account-related information.
                  I understand that message &amp; data rates may apply and that message frequency may vary.
                </label>
              </section>
              <div className="k-form-validation-message">
                <ErrorMessage errors={errors} name="terms" render={({ message }) => message} />
              </div>
            </div>
          )}
          <SubmitButton loading={loading} />
        </form>
      </section>
    </div>
  );
}

export default VerificationCodeSubmission;
